// extracted by mini-css-extract-plugin
module.exports = {"breakpoint-desktop":"(min-width: 992px)","container":"TeamListItemContent-module--container--39eac3","fade-in":"TeamListItemContent-module--fade-in--5d9ad0"};